






































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storeDischargePlanning } from "@/store/modules/DischargePlanningStore";
import DischargePlanningSvc from "@/services/dischargePlanningService";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { diagnoseAccess, unitKategoriLabel } from "@/utils/form-access";
import { formRoleOwners } from "@/utils/role-marker";
import { getHumanDateTime } from "@/utility/DateUtils";
import moment from "moment";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardDischargePlanning extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canWriteForm(): boolean {
    if (this.readOnly) return false;
    return (
      userModule.canAccessForm("discharge_planning", "create") ||
      userModule.canAccessForm("discharge_planning", "edit")
    );
  }

  get edukasiDeniedText(): string {
    if (this.readOnly) {
      return "Berkas sudah melewati batas waktu penyuntingan, pendidikan kesehatan tidak dapat ditambah.";
    }
    const u = userModule.user;
    const d = diagnoseAccess(
      u && u.unit_id,
      u && u.profesi,
      u && u.role && u.role.id,
      "discharge_planning",
      "create"
    );
    if (d.reason === "unit_mismatch") {
      const units = d.allowedUnitKategoriForProfesi
        .map(unitKategoriLabel)
        .join(", ");
      return `Anda belum bisa menambah pendidikan kesehatan dari unit ini. Khusus unit: ${units}.`;
    }
    const owners = formRoleOwners("discharge_planning")
      .map(o => o.label)
      .join(", ");
    return owners
      ? `Anda belum bisa menambah pendidikan kesehatan. Pengisian dilakukan oleh: ${owners}.`
      : "Anda belum bisa menambah pendidikan kesehatan.";
  }

  openPanels: number[] = [];
  savingSection: string | null = null;
  savingEdukasi = false;
  finalizing = false;
  menuTglEdukasi = false;

  // TTD modals
  modalTtdPerawat = false;
  modalTtdDpjp = false;
  modalTtdEdukasi = false;
  selectedEdukasiId: number | null = null;

  // Pasien dialog
  dialogPasien = false;
  pasienForm = { pasien_nama: "", pasien_hubungan: "" };

  // Edukasi form
  editingEdukasiId: number | null = null;
  edukasiForm = this.getEmptyEdukasiForm();

  // Master form (synced from currentItem)
  formMaster: any = this.getEmptyMasterForm();

  hubunganOptions = ["Suami", "Istri", "Anak", "Orang Tua", "Saudara", "Wali"];

  ppaOptions = [
    "Dokter Spesialis",
    "Dokter Umum",
    "Ners",
    "Perawat",
    "Apoteker",
    "Ahli Gizi",
    "Fisioterapis",
    "Bidan",
  ];

  mounted() {
    storeDischargePlanning.fetchByRegister(this.register);
  }

  @Watch("register")
  onRegisterChanged(val) {
    if (val) storeDischargePlanning.fetchByRegister(val);
  }

  get storeRef() {
    return storeDischargePlanning;
  }

  get currentItem() {
    const item = storeDischargePlanning.currentItem;
    if (!item) return null;
    if (String(item.register_id) !== String(this.register)) return null;
    return item;
  }

  get pasienData() {
    return storePasien.identitasPasien;
  }

  get isLocked() {
    if (this.readOnly) return true;
    return this.currentItem && this.currentItem.is_finalized;
  }

  get statusColor() {
    if (!this.currentItem) return "grey";
    switch (this.currentItem.status) {
      case "SELESAI": return "green";
      case "DALAM PROSES": return "orange";
      default: return "grey";
    }
  }

  get edukasiFormValid() {
    return (
      this.edukasiForm.pendidikan_kesehatan &&
      this.edukasiForm.pendidikan_kesehatan.length >= 5 &&
      this.edukasiForm.ppa &&
      this.edukasiForm.tanggal
    );
  }

  @Watch("currentItem")
  onCurrentItemChanged(val) {
    if (val) {
      this.syncMasterForm(val);
    }
  }

  getEmptyMasterForm() {
    return {
      transportasi_pulang: "",
      pendamping_nama: "",
      pendamping_hubungan: "",
      diet_khusus: "",
      alat_oxygen_portable: false,
      alat_tracheostomi: false,
      alat_dkateter: false,
      alat_ngt: false,
      alat_medis_lainnya: "",
      alat_bantu_kursi_roda: false,
      alat_bantu_tongkat: false,
      alat_bantu_lainnya: "",
      monitoring_oleh: "",
      rs_menghubungi: "",
    };
  }

  getEmptyEdukasiForm() {
    return {
      pendidikan_kesehatan: "",
      ppa: "",
      tanggal: moment().format("YYYY-MM-DD"),
    };
  }

  syncMasterForm(item) {
    this.formMaster = {
      transportasi_pulang: item.transportasi_pulang || "",
      pendamping_nama: item.pendamping_nama || "",
      pendamping_hubungan: item.pendamping_hubungan || "",
      diet_khusus: item.diet_khusus || "",
      alat_oxygen_portable: item.alat_oxygen_portable || false,
      alat_tracheostomi: item.alat_tracheostomi || false,
      alat_dkateter: item.alat_dkateter || false,
      alat_ngt: item.alat_ngt || false,
      alat_medis_lainnya: item.alat_medis_lainnya || "",
      alat_bantu_kursi_roda: item.alat_bantu_kursi_roda || false,
      alat_bantu_tongkat: item.alat_bantu_tongkat || false,
      alat_bantu_lainnya: item.alat_bantu_lainnya || "",
      monitoring_oleh: item.monitoring_oleh || "",
      rs_menghubungi: item.rs_menghubungi || "",
    };
  }

  formatDate(date) {
    if (!date) return "-";
    const m = moment(date);
    return m.isValid() ? m.format("DD-MM-YYYY") : "-";
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  refresh() {
    storeDischargePlanning.fetchByRegister(this.register);
  }

  // ==================== Section Save ====================

  async saveSection(section: string) {
    this.savingSection = section;
    try {
      let payload = {};

      switch (section) {
        case "transportasi":
          payload = {
            transportasi_pulang: this.formMaster.transportasi_pulang,
            pendamping_nama: this.formMaster.pendamping_nama,
            pendamping_hubungan: this.formMaster.pendamping_hubungan,
          };
          break;
        case "diet":
          payload = { diet_khusus: this.formMaster.diet_khusus };
          break;
        case "alat_medis":
          payload = {
            alat_oxygen_portable: this.formMaster.alat_oxygen_portable,
            alat_tracheostomi: this.formMaster.alat_tracheostomi,
            alat_dkateter: this.formMaster.alat_dkateter,
            alat_ngt: this.formMaster.alat_ngt,
            alat_medis_lainnya: this.formMaster.alat_medis_lainnya,
          };
          break;
        case "alat_bantu":
          payload = {
            alat_bantu_kursi_roda: this.formMaster.alat_bantu_kursi_roda,
            alat_bantu_tongkat: this.formMaster.alat_bantu_tongkat,
            alat_bantu_lainnya: this.formMaster.alat_bantu_lainnya,
          };
          break;
        case "monitoring":
          payload = {
            monitoring_oleh: this.formMaster.monitoring_oleh,
            rs_menghubungi: this.formMaster.rs_menghubungi,
          };
          break;
      }

      const resp = await DischargePlanningSvc.update(this.currentItem.id, payload);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil disimpan");
        this.refresh();
      }
    } finally {
      this.savingSection = null;
    }
  }

  // ==================== Edukasi CRUD ====================

  editEdukasi(edu) {
    this.editingEdukasiId = edu.id;
    this.edukasiForm = {
      pendidikan_kesehatan: edu.pendidikan_kesehatan,
      ppa: edu.ppa,
      tanggal: edu.tanggal ? moment(edu.tanggal).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
    };
  }

  cancelEditEdukasi() {
    this.editingEdukasiId = null;
    this.edukasiForm = this.getEmptyEdukasiForm();
  }

  async simpanEdukasi() {
    this.savingEdukasi = true;
    try {
      let resp;
      if (this.editingEdukasiId) {
        resp = await DischargePlanningSvc.updateEdukasi(
          this.currentItem.id,
          this.editingEdukasiId,
          this.edukasiForm
        );
      } else {
        resp = await DischargePlanningSvc.addEdukasi(this.currentItem.id, this.edukasiForm);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay(this.editingEdukasiId ? "Edukasi berhasil diupdate" : "Edukasi berhasil ditambahkan");
        this.editingEdukasiId = null;
        this.edukasiForm = this.getEmptyEdukasiForm();
        this.refresh();
      }
    } finally {
      this.savingEdukasi = false;
    }
  }

  async hapusEdukasi(edu) {
    if (!confirm("Hapus pendidikan kesehatan ini?")) return;

    try {
      const resp = await DischargePlanningSvc.deleteEdukasi(this.currentItem.id, edu.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Edukasi berhasil dihapus");
        this.refresh();
      }
    } catch {
      // handled by service
    }
  }

  // ==================== Signature: PPA Edukasi ====================

  openTtdEdukasi(edu) {
    this.selectedEdukasiId = edu.id;
    this.modalTtdEdukasi = true;
  }

  async passTtdEdukasi(password: string) {
    if (!this.selectedEdukasiId) return;
    try {
      const resp = await DischargePlanningSvc.signPpaEdukasi(
        this.currentItem.id,
        this.selectedEdukasiId,
        { password }
      );
      if (resp.data.status == "1") {
        this.modalTtdEdukasi = false;
        appModule.NoticeDelay("Berhasil memparaf edukasi");
        appModule.addMsgTtd("");
        this.selectedEdukasiId = null;
        this.refresh();
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtdEdukasi = true;
      }
    } catch {
      // handled by service
    }
  }

  // ==================== Signature: Perawat ====================

  openTtdPerawat() {
    this.modalTtdPerawat = true;
  }

  async passTtdPerawat(password: string) {
    try {
      const resp = await DischargePlanningSvc.signPerawat(this.currentItem.id, { password });
      if (resp.data.status == "1") {
        this.modalTtdPerawat = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan Perawat Ruang");
        appModule.addMsgTtd("");
        this.refresh();
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtdPerawat = true;
      }
    } catch {
      // handled by service
    }
  }

  // ==================== Signature: DPJP ====================

  openTtdDpjp() {
    this.modalTtdDpjp = true;
  }

  async passTtdDpjp(password: string) {
    try {
      const resp = await DischargePlanningSvc.signDpjp(this.currentItem.id, { password });
      if (resp.data.status == "1") {
        this.modalTtdDpjp = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan DPJP");
        appModule.addMsgTtd("");
        this.refresh();
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtdDpjp = true;
      }
    } catch {
      // handled by service
    }
  }

  // ==================== Signature: Pasien (Manual Mark) ====================

  async tandaiPasien() {
    try {
      const resp = await DischargePlanningSvc.markPasien(this.currentItem.id, this.pasienForm);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil menandai tanda tangan Pasien/Keluarga");
        this.dialogPasien = false;
        this.pasienForm = { pasien_nama: "", pasien_hubungan: "" };
        this.refresh();
      }
    } catch {
      // handled by service
    }
  }

  // ==================== Finalize ====================

  async doFinalize() {
    if (!confirm("Finalisasi discharge planning? Setelah difinalisasi, data tidak dapat diubah lagi.")) return;

    this.finalizing = true;
    try {
      const resp = await DischargePlanningSvc.finalize(this.currentItem.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Discharge planning berhasil difinalisasi");
        this.refresh();
      }
    } finally {
      this.finalizing = false;
    }
  }

  // ==================== PDF ====================

  cetakPdf() {
    if (this.currentItem && this.currentItem.id) {
      DischargePlanningSvc.print(this.currentItem.id);
    }
  }
}
